import { Bus } from '../types/busTypes';

const buildUpsertPayload = (
  busData: Bus,
  updatedata: Partial<Bus> = {},
  additionalData: Partial<Bus> = {}
) => {
  const combinedData = { ...busData, ...updatedata } as Bus;
  const identifier = combinedData._id || combinedData.id || '';
  return {
    id: identifier,
    name: combinedData.name,
    licensePlateNo: combinedData.licensePlateNo,
    school: combinedData.school,
    deviceId: combinedData.deviceId ?? null,
    ...additionalData
  };
};

const formatQrPayload = (busId: string) => `"{"busId": "${busId}"}"`;

export { buildUpsertPayload, formatQrPayload };
